module.exports = __webpack_public_path__ + "static/3-af0249a5c2d25a22a19978665b8c08bc.jpg";